export const getActivityColor = (activityPct, hex = false) => {
  if (activityPct >= 80) {
    return hex ? '#0eb01d' : 'green';
  } else if (activityPct >= 61) {
    return hex ? '#adcfff' : 'blue';
  } else if (activityPct >= 51) {
    return hex ? '#f8d8ab' : 'yellow';
  } else {
    return hex ? '#ff383c' : 'red';
  }
};

// Same tiers as getActivityColor, but a dark, high-contrast token meant for
// text on a light background. getActivityColor's hex values are pale
// badge-*background* colors (e.g. #adcfff) — used as text color directly,
// they're nearly invisible (e.g. light blue on white).
export const getActivityTextColor = (activityPct) => {
  const tierTextColors = {
    green: 'var(--success-700)',
    blue: 'var(--blue-700)',
    yellow: 'var(--warning-700)',
    red: 'var(--error-700)',
  };
  return tierTextColors[getActivityColor(activityPct)] || 'var(--gray-900)';
};

// Same tiers again, as a bare color token (no `var()` wrapper) for
// StatusDot's `color` prop, which builds `var(--${color})` itself.
export const getActivityDotColor = (activityPct) => {
  const tierDotColors = {
    green: 'success-500',
    blue: 'blue-500',
    yellow: 'warning-500',
    red: 'error-500',
  };
  return tierDotColors[getActivityColor(activityPct)] || 'gray-400';
};
